import { useState } from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import {
  updateJobAlertCreateDialog,
  updateJobAlertCreateDialogWithKeyword,
  updateVisitorJobAlertDialogDetails,
  updateVisitorJobAlertDialogOrigin,
} from "../../../redux/actions/dialog_action";
import {
  updateJobAlertEmail,
  updateShowJobAlertDialog,
} from "../../../redux/actions/job_action";
import {
  AlertContainer,
  BellIconStyled,
  BoxStyled,
  ButtonStyled,
  CloseIconStyled,
  EnvelopeIconStyled,
  InputAdornmentStyled,
  InputBaseStyled,
  TextStyled,
} from "./styles";

function JobAlertSticky(props) {
  const dispatch: any = useDispatch();
  const [email, setEmail] = useState("");
  const [hideContainer, sethideContainer] = useState(false);
  const { t } = useTranslation();

  const title = props.job.title;

  function onInputUpdate(event) {
    setEmail(event.target.value);
    dispatch(
      updateVisitorJobAlertDialogDetails({
        email: event.target.value,
      })
    );
    dispatch(updateJobAlertEmail(event.currentTarget.value));
  }

  function handleSetAlert() {
    // dispatch(
    //   updateVisitorJobAlertDialogDetails({
    //     keyword: title ?? "",
    //   })
    // );
    // dispatch(updateVisitorJobAlertDialogOrigin("single-job-page"));
    // dispatch(updateShowJobAlertDialog(true));
    dispatch(
      updateJobAlertCreateDialogWithKeyword({
        keyword: title ?? "",
        origin: "single-job-page",
      })
    );
    dispatch(updateJobAlertCreateDialog(true));
    sethideContainer(true);
  }

  function handleClose() {
    sethideContainer(true);
  }

  return (
    <AlertContainer sx={hideContainer && { display: "none" }}>
      <BoxStyled typeof="left">
        <BellIconStyled />
        <TextStyled>{t("jobs.job_alert_sticky.title")}</TextStyled>
      </BoxStyled>
      <BoxStyled typeof="right">
        <InputBaseStyled
          id="email"
          placeholder={t("jobs.job_alert_sticky.email_placeholder")}
          onChange={onInputUpdate}
          size="small"
          startAdornment={
            <InputAdornmentStyled position="start">
              <EnvelopeIconStyled />
            </InputAdornmentStyled>
          }
          onKeyDown={(event) => {
            if (event.key === "Enter") {
              handleSetAlert();
            }
          }}
        ></InputBaseStyled>
        <ButtonStyled variant="contained" onClick={handleSetAlert}>
          {t("jobs.job_alert_sticky.set_alert")}
        </ButtonStyled>
      </BoxStyled>
      <CloseIconStyled onClick={handleClose} />
    </AlertContainer>
  );
}

export default JobAlertSticky;
